export default {
  name: 'test-result-question-text',
  props: {
    item: {}
  }
}
